import { render } from "./BabylonExample.vue?vue&type=template&id=65f328a7&scoped=true&ts=true"
import script from "./BabylonExample.vue?vue&type=script&lang=ts"
export * from "./BabylonExample.vue?vue&type=script&lang=ts"

import "./BabylonExample.vue?vue&type=style&index=0&id=65f328a7&scoped=true&lang=css"

import exportComponent from "/Users/macosx/DEVELOPER/DevPersonal/08-3D WEBSITE/testing_babylonjs/babylonstart/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f328a7"]])

export default __exports__